import * as types from '../actions/action-types';
import _ from 'lodash';

const initialState = {
    showInfiniteScrollLoader: false
};

const uiReducer = function(state = initialState, action) {

    let newState;
    switch(action.type) {
        case types.SHOW_INFINITE_SCROLL_LOADER:
            newState = Object.assign({}, state);
            newState.showInfiniteScrollLoader =  action.showLoader;
            return newState;
        default:
            return state;
    }

};

export default uiReducer;
